import { isFinite, clamp } from 'lodash';

const QTY_MAX = 99999;

export default {
  restrict(val) {
    val = parseInt(val, 10);
    if (!isFinite(val)) {
      return null;
    }
    return clamp(Math.floor(val), 1, QTY_MAX);
  },
  inputProps: {
    type: 'number',
    max: QTY_MAX,
    min: 1,
    step: 1,
  },
  QTY_MAX,
};
